import { useState } from 'react';
import { PaginationUpdateEvent } from 'ui/paginationFooter';

export const usePagination = () => {
  const [limit, setLimit] = useState<number>(10);
  const [offset, setOffset] = useState<number>(0);
  const [count, setCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);

  const handlePageChange = ({ page: newPage, pageSize }: PaginationUpdateEvent) => {
    setLimit(pageSize);
    setOffset((newPage - 1) * pageSize);
    setPage(newPage);
  };

  const resetPagination = () => {
    setOffset(0);
    setPage(1);
  };

  const pagination = { limit, offset, count, page };

  return { pagination, setCount, handlePageChange, resetPagination };
};
